const PREFIX = process.env.VUE_APP_API + "/api";
const API = {
  // 登陆接口
  login: `${PREFIX}/auth/teacher/phone-login`,

  // 通用数据
  districts: `${PREFIX}/districts/all`,
  school: `${PREFIX}/const/schools`,
  subject: `${PREFIX}/const/subjects`,
  grades: `${PREFIX}/const/grades`,
  //学生作品
  studentWork: `${PREFIX}/teacher/student-works`,
  studentWorkId: id => `${PREFIX}/teacher/student-works/${id}`,
  // 我的学生作品
  myStudentWork: `${PREFIX}/teacher/personal-center/student-works`,
  myStudentWorkId: id =>
    `${PREFIX}/teacher/personal-center/student-works/${id}`,
  // 我的订阅

  // 获取教师教授科目
  // 获取/编辑教师个人信息
  userInfo: `${PREFIX}/teacher/personal-center/profile`,
  // 设置新密码
  setPwd: `${PREFIX}/teacher/personal-center/profile/set-pw`,
  // 获取当前教师班级列表
  class: `${PREFIX}/teacher/personal-center/classrooms/my`,
  classCreate: `${PREFIX}/teacher/personal-center/classrooms`,
  // 班级id
  classId: id => `${PREFIX}/teacher/personal-center/classrooms/${id}`,
  // 课件
  courseware: `${PREFIX}/teacher/coursewares`,
  coursewareId: id => `${PREFIX}/teacher/coursewares/${id}`,
  coursewareRecommends: `${PREFIX}/teacher/coursewares/recommends`,
  coursewareIdSub: id => `${PREFIX}/teacher/coursewares/${id}/subscribe`,
  coursewareIdCancelSub: id =>
    `${PREFIX}/teacher/coursewares/${id}/unsubscribe`,
  coursewareDownload: id => `${PREFIX}/teacher/coursewares/${id}/download`,
  // 新增班级
  coursewareSub: `${PREFIX}/teacher/personal-center/courseware-subscribes`,
  coursewareSubId: id =>
    `${PREFIX}/teacher/personal-center/courseware-subscribes/${id}`,
  coursewareFeb: `${PREFIX}/teacher/personal-center/courseware-feedbacks`,
  coursewareFebId: id =>
    `${PREFIX}/teacher/personal-center/courseware-feedbacks/${id}`,
  // 兑换
  gift: `${PREFIX}/teacher/gift/gifts`,
  giftOrder: id => `${PREFIX}/teacher/gift/gifts/${id}/order`,
  myGift: `${PREFIX}/teacher/gift/my/gifts`,

  // 兑换地址
  address: `${PREFIX}/teacher/gift/addresses`,
  addressId: id => `${PREFIX}/teacher/gift/addresses/${id}`,
  addressIdDefault: id => `${PREFIX}/teacher/gift/addresses/${id}/set-default`,
  addressDefault: `${PREFIX}/teacher/gift/addresses/default`,

  // 评论/回复
  comment: id => `${PREFIX}/teacher/student-works/${id}/comments`,
  commentPraise: (workId, commentId) =>
    `${PREFIX}/teacher/student-works/${workId}/comments/${commentId}/praise`,
  commentTip: (workId, commentId) =>
    `${PREFIX}/teacher/student-works/${workId}/comments/${commentId}/tip`,
  commentReply: (workId, commentId) =>
    `${PREFIX}/teacher/student-works/${workId}/comments/${commentId}/replies`,
  // 回复评论

  // 阿里云oss
  ossToken: `${PREFIX}/upload/oss/token`,
  ossStore: `${PREFIX}/upload/oss/file`,
  ossUrl: "https://shiguangfiles.oss-cn-beijing.aliyuncs.com"
};
export default API;
